import { CONFIG } from '../../config';

export const fetchFeatureFlags = () =>
  fetch(`${CONFIG.DISCOVERY_API_URL}/feature-flags`).then(response => response.json());
